// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controlled-checkbox {
  position: relative !important;
  width: 20px !important;
  height: 20px !important;
  cursor: pointer !important;
  -webkit-appearance: none !important;
     -moz-appearance: none !important;
          appearance: none !important;
  border-radius: 4px !important;
  border: 1px solid #cbd5e0 !important;
  transition: all 0.3s !important;
  visibility: visible !important;
  margin-bottom: 0 !important;
}

.controlled-checkbox::before {
  content: '' !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  display: block !important;
  height: 12px !important;
  width: 12px !important;
  transform: translate(-50%, -50%) !important;
  border-radius: 50% !important;
  background-color: #4a5568 !important;
  opacity: 0 !important;
  transition: opacity 0.3s !important;
  visibility: visible !important;
  margin-bottom: 0 !important;
}

.controlled-checkbox:checked {
  border-color: #4a5568 !important;
  background-color: #4a5568 !important;
  visibility: visible !important;
  margin-bottom: 0 !important;
}

.controlled-checkbox:checked::before {
  background-color: #4a5568 !important;
  opacity: 1 !important;
  visibility: visible !important;
  margin-bottom: 0 !important;
}

.controlled-checkbox:hover::before {
  opacity: 0.1 !important;
  visibility: visible !important;
  margin-bottom: 0 !important;
}

.controlled-checkbox:checked::after {
  content: '\\2713' !important;
  position: absolute !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  font-size: 14px !important;
  color: white !important;
}

.controlled-checkbox-overlay {
  position: absolute !important;
  color: white !important;
  transition: opacity 0.3s !important;
  opacity: 0 !important;
  pointer-events: none !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin-bottom: 0 !important;
}

.controlled-checkbox-overlay.peer-checked {
  opacity: 1 !important;
  margin-bottom: 0 !important;
}

.controlled-checkbox-label {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  margin-right: 8px !important;
  border-radius: 9999px !important;
  cursor: pointer !important;
  margin-bottom: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/shared-widget-components/src/components/ControlledInputs/checkbox.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,mCAA2B;KAA3B,gCAA2B;UAA3B,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,2CAA2C;EAC3C,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mCAAmC;EACnC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,mCAAmC;EACnC,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;AAC7B","sourcesContent":[".controlled-checkbox {\r\n  position: relative !important;\r\n  width: 20px !important;\r\n  height: 20px !important;\r\n  cursor: pointer !important;\r\n  appearance: none !important;\r\n  border-radius: 4px !important;\r\n  border: 1px solid #cbd5e0 !important;\r\n  transition: all 0.3s !important;\r\n  visibility: visible !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.controlled-checkbox::before {\r\n  content: '' !important;\r\n  position: absolute !important;\r\n  top: 50% !important;\r\n  left: 50% !important;\r\n  display: block !important;\r\n  height: 12px !important;\r\n  width: 12px !important;\r\n  transform: translate(-50%, -50%) !important;\r\n  border-radius: 50% !important;\r\n  background-color: #4a5568 !important;\r\n  opacity: 0 !important;\r\n  transition: opacity 0.3s !important;\r\n  visibility: visible !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.controlled-checkbox:checked {\r\n  border-color: #4a5568 !important;\r\n  background-color: #4a5568 !important;\r\n  visibility: visible !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.controlled-checkbox:checked::before {\r\n  background-color: #4a5568 !important;\r\n  opacity: 1 !important;\r\n  visibility: visible !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.controlled-checkbox:hover::before {\r\n  opacity: 0.1 !important;\r\n  visibility: visible !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.controlled-checkbox:checked::after {\r\n  content: '\\2713' !important;\r\n  position: absolute !important;\r\n  top: 50% !important;\r\n  left: 50% !important;\r\n  transform: translate(-50%, -50%) !important;\r\n  font-size: 14px !important;\r\n  color: white !important;\r\n}\r\n\r\n.controlled-checkbox-overlay {\r\n  position: absolute !important;\r\n  color: white !important;\r\n  transition: opacity 0.3s !important;\r\n  opacity: 0 !important;\r\n  pointer-events: none !important;\r\n  top: 50% !important;\r\n  left: 50% !important;\r\n  transform: translate(-50%, -50%) !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.controlled-checkbox-overlay.peer-checked {\r\n  opacity: 1 !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.controlled-checkbox-label {\r\n  position: relative !important;\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  margin-right: 8px !important;\r\n  border-radius: 9999px !important;\r\n  cursor: pointer !important;\r\n  margin-bottom: 0 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
